import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { take } from 'rxjs/operators';
import { GeneralProductsProducts } from 'src/app/services/service/DataProviders/GeneralProductsProducts';
import { ProductionShopFloorWorkOrders } from 'src/app/services/service/DataProviders/ProductionShopFloorWorkOrders';

@Component({
  selector: 'analysis-po',
  templateUrl: './analysis-po.component.html',
  styleUrls: ['./analysis-po.component.scss']
})
export class AnalysisPOComponent implements OnInit {

  public tehnologieChoose;
  public poTreeChoose;
  public printsChoose;
  public poAnalysis;
  public poWorkCard;

  public filterForm: FormGroup;
  public poNumber = null;

  public tree = [];

  public processRecipe = false;
  public recepiesToProcess = [];

  public productionOrder = null;
  public poList = [];

  constructor(
    private productService: GeneralProductsProducts,
    private woService: ProductionShopFloorWorkOrders,
    ) {
    this.createFilterForm();
  }

  ngOnInit() {
  }

  selectPoFromMultiple(po) {
    this.productionOrder = po;
    this.poList = [];
    this.loadPoOrder();
  }

  async loadPoOrders() {
    this.processRecipe = false;
    if (!_.isEmpty(this.filterForm.value.poNumber)) {
      this.poNumber = _.get(this.filterForm, 'value.poNumber');
      let res = await <any>this.woService.findByNumber(this.poNumber).pipe(take(1)).toPromise();
      if (!_.isArray(res.value) || res.value.length == 0) {
        alert("Не е намерено ПН");
        return;
      }

      this.recepiesToProcess = [];
      if(res.value.length == 1) {
        this.selectPoFromMultiple(res.value[0]);
      }
      else {
        this.poList = res.value;
      }
    }
  }

  async loadPoOrder() {
    let item = _.get(this.productionOrder, 'Items[0]', null);
    this.processRecipe = false;
    this.tree = [];
    this.recepiesToProcess = [];
    this.recepiesToProcess.push(item);
    this.processRecipe = true;
  }

  private createFilterForm() {
    this.filterForm = new FormGroup({
      poNumber: new FormControl(
        // '0000019530'
        // '0000010917'
        // '0000000037'
        // '0000010917'
        // '0000011857'
        ''
        , [
        Validators.required
      ])
    });
  }

  resetForm() {
    this.processRecipe = false;
    this.tree = [];
    this.recepiesToProcess = [];
    this.filterForm.reset();
  }


}
